export const abortControllerFromStack = (stack: DisposableStack) => {
  return stack.adopt(new AbortController(), controller => (controller.signal.aborted ? null : controller.abort()))
}

export const bindStackToAbortSignal = (stack: DisposableStack, signal: AbortSignal) => {
  if (signal.aborted) {
    stack.dispose()
    return
  }
  signal.addEventListener(
    'abort',
    stack.adopt(
      () => {
        if (!stack.disposed) stack.dispose()
      },
      h => signal.removeEventListener('abort', h)
    )
  )
}
